import { render, staticRenderFns } from "./StackableActions.vue?vue&type=template&id=6a4454f0&scoped=true"
import script from "./StackableActions.vue?vue&type=script&lang=js"
export * from "./StackableActions.vue?vue&type=script&lang=js"
import style0 from "./StackableActions.vue?vue&type=style&index=0&id=6a4454f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4454f0",
  null
  
)

export default component.exports